import { Button, DateInput, Modal, ApprovalAlert } from "components";
import { Fragment, useState } from "react";
import toast from "react-hot-toast";
import moment from "moment";
import { IoSendSharp } from "react-icons/io5";
import { useApi, useToggle } from "utils";
import { ApproveType } from "../types";
import { Detail } from "../../RefundReturnItem/components";
import { PERMISION } from "security";



export function ApproveAction(props:{
    data: any,
    refetch: () => void
}) {
    const { isActive, toggle } = useToggle(false)
    
    return (
        <Fragment>
            <Button 
                type="button" 
                color="ghost"
                permission={PERMISION.SALES.TRANSACTION.REFUND_RETURN_APPROVAL.UPDATE} 
                onClick={toggle} 
                disabled={Boolean(props?.data?.approve_status === 2 || props?.data?.approve_status === 4)}
                >
                <IoSendSharp />
            </Button>
            {isActive && <ModalSection toggle={toggle} data={props.data} refetch={props.refetch} />}
        </Fragment>
    )
}

function ModalSection(params: {
    toggle: () => void,
    data: ApproveType
    refetch: () => void
}): JSX.Element {
    const api = useApi()
	const [date, setDate] = useState<string>(moment().format("YYYY-MM-DD"))


    const onSubmit = (date: string, status: number) => {
        return new Promise<void>((resolve) => {
            toast.promise(
                api.post(`/received/approve_refund_return?refund_return_id=${params.data.refund_return_id}`, {
                    approve_status: status,
                    approve_date: date 
                }),
                {
                    loading: "Loading...",
                    success: (res: any) => res.data.message,
                    error: (err) => err.response.data.message ?? err.response.message
                }
            ).then(() => {
                params.toggle()
                params?.refetch && params.refetch()
            }).catch(() => { }).finally(resolve)
        })
    }

    return (
        <Modal
			isdarktitle
			isOpen
			title="APPROVE RETURN REFUND"
			closeModal={params.toggle}
		>
			<Modal.Body>
                <Detail refund_return_id={params.data.refund_return_id.toString()} />
			</Modal.Body>

			<Modal.Footer className="flex md:flex-row flex-col justify-between md:items-end gap-3">
				<DateInput
					placeholderText="Select Date"
					selected={moment(date).toDate()}
					className="w-full"
					label="APPROVAL DATE"
					onChange={(date) => {
						const selectDate = moment(date).format("YYYY-MM-DD")
						setDate(selectDate)
					}}
				/>

				<section className="flex gap-3">
					<Button onClick={params.toggle}>CANCEL</Button>
					<Button color="error" onClick={() => onSubmit(date, 3)}>REJECT</Button>
					<Button color="primary" 
                        onClick={() => {
                            if(params.data.transaction_date !== date){
                                ApprovalAlert("Approval date is different from transaction date").then(async (res) => {
                                  if (res.isConfirmed) {
                                    onSubmit(date, 4)
                                  }else{
                                    return
                                  }
                                })
                              }else{
                                onSubmit(date, 4)
                              }  
                        }}
                    >
                        APPROVE
                    </Button>
				</section>
			</Modal.Footer>
		</Modal>
    )
}

